import { Component, Input, OnInit } from '@angular/core';
import { IEvent } from '../../../services/announcement/models/event.interface';

@Component({
  selector: 'upsc-event-item',
  templateUrl: './event-item.component.html',
  styleUrls: ['./event-item.component.scss'],
})
export class EventItemComponent implements OnInit {
  @Input() item: IEvent;

  constructor() {
  }

  public ngOnInit() {
    if (this.item && this.item.EventURL) {
      if (!this.item.EventURL.match(/^[a-zA-Z]+:\/\//)) {
        this.item.EventURL = `http://${this.item.EventURL}`;
      }
    }
  }
}
